<div class="side-nav-spacer" *ngIf="!isRegulatorUser"></div>
<div class="footer" id="footer">
  <div class="left-column">
    <ng-container *ngIf="viewType === 'dataEntry'">
      <!-- NOTE: Bring this back if you want completeness checks on the form-->
      <a
        *ngIf="isDraft"
        class="icon-button"
        (click)="onValidate()"
        tabindex="0"
        id="completeness-check-button"
        aria-label="Run Completeness Checks"
      >
        <finra-icon [icon]="'Tasks'" size="xs"></finra-icon>
        <span class="blue-70">Completeness Check</span>
      </a>
      <a
        *ngIf="section?.split(';')[0] !== 'guidance'"
        class="icon-button"
        (click)="onFormView()"
        tabindex="0"
        id="form-view-button"
      >
        <finra-icon family="light" icon="Print" size="xs"></finra-icon>
        <span class="blue-70">Form View</span>
      </a>
      <a
        *ngIf="isDraft && !(displayRules$ | async)?.readOnlyMode"
        [ngClass]="{ disabled: saveInProgress }"
        class="icon-button"
        aria-label="Save Mu1 form"
        (click)="saveData()"
        tabindex="0"
        id="save-button"
      >
        <finra-icon family="light" icon="Save" size="xs"></finra-icon>
        <span class="blue-70">{{ saveInProgress ? 'Saving...' : 'Save' }}</span>
      </a>
      <span *ngIf="isDraft && (autoSaveData$ | async) as autoSaveData" class="save-data">
        <span style="padding-right: 5px; font-size: 15px">{{ ' | ' }}</span>
        {{ autoSaveData }}
      </span>
    </ng-container>

    <ng-container *ngIf="viewType === 'formView'">
      <span class="icon-button redline-button">
        <label class="switch change">
          <span class="visually-hidden">Non Empty Form Label</span>
          <input
            id="redline-input"
            tabindex="1"
            type="checkbox"
            (change)="onToggleRedline($any($event.target).checked)"
            [checked]="showRedlines$ | async"
            aria-label="Toggle View All Changes"
          />
          <span id="redline-slider" tabindex="0" class="slider round" aria-label="Toggle View Changes"></span>
        </label>
        <span>View Changes</span>
      </span>
      <a *ngIf="!isRegulatorUser" class="icon-button" (click)="onPrint()" tabindex="0" id="print-button">
        <finra-icon family="light" icon="Print" size="xs"></finra-icon>
        <span class="blue-70">Print Form</span>
      </a>
    </ng-container>
  </div>
  <div class="right-column">
    <ng-container *ngIf="viewType === 'dataEntry'">
      <!-- NOTE: bring this back for navigation between sections if it is needed-->
      <finra-button
        *ngIf="!(section === this?.sectionNavData[0]?.children.at(0)?.id)"
        (click)="onBack()"
        theme="secondary"
        size="md"
        [disabled]="disablePreviousButton()"
        [attr.aria-label]="'Navigate to ' + footerButtonTextSetter(section, 'previous') + ' section'"
      >
        <div class="footer-previous-button">
          <span class="arrow-align">&#60;</span>
          <div>{{ footerButtonTextSetter(section, 'previous') }}</div>
        </div>
      </finra-button>
      <finra-button
        *ngIf="!(section === this?.sectionNavData[0]?.children.at(-1)?.id)"
        (click)="onNext()"
        theme="primary"
        size="md"
        [attr.aria-label]="'Navigate to ' + footerButtonTextSetter(section, 'next') + ' section'"
      >
        {{ footerButtonTextSetter(section, 'next') + ' &#62;' }}
      </finra-button>
      <finra-button
        *ngIf="(displayRules$ | async)?.canRequestAttestation && section === 'attestAndSubmit'"
        (click)="requestAttestation()"
        theme="primary"
        size="md"
        [disabled]="isRequestAttestationDisabledSub$ | async"
        aria-label="Request Attestation from Individual"
      >
        REQUEST ATTESTATION
      </finra-button>
      <finra-button
        *ngIf="(displayRules$ | async)?.canAttest && section === 'attestAndSubmit'"
        (click)="attestData()"
        theme="primary"
        size="md"
        [disabled]="isDisableSub$ | async"
        aria-label="Attest the filing"
      >
        ATTEST
      </finra-button>
      <finra-button
        *ngIf="(displayRules$ | async)?.canSubmit && section === 'attestAndSubmit'"
        (click)="openTermsModal()"
        theme="primary"
        size="md"
        [disabled]="isDisableSub$ | async"
        aria-label="Submit Filing"
      >
        Submit Filing
      </finra-button>
      <!-- &&(displayRules$ | async)?.canRequestAttestation -->
      <!-- <finra-button *ngIf="isDraft && section === this?.sectionNavData[0]?.children.at(-1)?.id"
        [disabled]="isWebCRDDown || saveInProgress" (click)="!isWebCRDDown && onSubmit()" theme="primary" size="md">
        {{ saveInProgress ? 'Submitting...' : 'Submit' }}
      </finra-button> -->
    </ng-container>

    <ng-container *ngIf="viewType === 'formView' && !isInstanceSuccessfullyProcessed && !isRegulatorUser">
      <finra-button
        (click)="
          closeRedlineWidget();
          openFormSection('dataEntry', lastOpenedSectionDE || 'standard1', { state: { beastNavEventKey: 'fv:back' } })
        "
        [theme]="'primary'"
        size="md"
        aria-label="Back"
      >
        Back
      </finra-button>
    </ng-container>
  </div>
</div>
